
	(function () {
		var root = document.getElementById('nn-water-template--27862111027294__tool');
		if (!root || root.dataset.nnReady === '1') return;
		root.dataset.nnReady = '1';

		var LB_TO_KG = 0.45359237, OZ_TO_ML = 29.5735;
		var ML_PER_KG = 35, ML_PER_HALF_HOUR = 300, CREATINE_ML = 500, CAP = 6000;
		var GLASS = 240, BOTTLE = 500;
		var CLIMATE = { temperate: 0, warm: 500, hot: 1000 };
		var CLIMATE_DETAIL = {
			temperate: 'Under 24C / 75F',
			warm: '24 to 29C / 75 to 85F',
			hot: 'Above 29C / 85F'
		};

		var q = function (s) { return root.querySelector(s); };
		var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
		var state = { units: 'imperial', exercise: 30, climate: 'temperate', creatine: false };

		function amount(ml) {
			if (state.units === 'metric') {
				return ml >= 1000 ? (ml / 1000).toFixed(1) + ' L' : Math.round(ml) + ' ml';
			}
			return Math.round(ml / OZ_TO_ML) + ' oz';
		}

		function render() {
			var raw = parseFloat(q('[data-weight]').value);
			var kg = isFinite(raw) ? (state.units === 'metric' ? raw : raw * LB_TO_KG) : NaN;
			var ok = isFinite(kg) && kg >= 27 && kg <= 227;

			q('[data-weight-hint]').hidden = ok;
			q('[data-weight]').setAttribute('data-invalid', String(!ok));
			q('[data-climate-detail]').textContent = CLIMATE_DETAIL[state.climate];

			if (!ok) return;

			var baseline = kg * ML_PER_KG;
			var exercise = (Math.max(0, state.exercise) / 30) * ML_PER_HALF_HOUR;
			var heat = CLIMATE[state.climate];
			var creatine = state.creatine ? CREATINE_ML : 0;

			var parts = [{ label: 'Your body size', ml: baseline }];
			if (exercise > 0) parts.push({ label: 'Exercise', ml: exercise });
			if (heat > 0) parts.push({ label: state.climate === 'hot' ? 'Hot climate' : 'Warm climate', ml: heat });
			if (creatine > 0) parts.push({ label: 'Creatine', ml: creatine });

			var rawTotal = baseline + exercise + heat + creatine;
			var total = Math.min(rawTotal, CAP);

			q('[data-total]').textContent = amount(total);
			q('[data-glasses]').textContent = String(Math.round(total / GLASS));
			q('[data-bottles]').textContent = String(Math.round(total / BOTTLE));
			q('[data-hourly]').textContent = 'About ' + amount(total / 16) + ' an hour';
			q('[data-cap-note]').hidden = rawTotal <= CAP;

			var tbody = q('[data-parts]');
			tbody.innerHTML = '';
			parts.forEach(function (p) {
				var tr = document.createElement('tr');
				var a = document.createElement('td');
				a.textContent = p.label;
				var b = document.createElement('td');
				b.className = 'nn-num';
				b.textContent = amount(p.ml);
				tr.appendChild(a);
				tr.appendChild(b);
				tbody.appendChild(tr);
			});

			q('[data-nudge-copy]').textContent = state.creatine
				? 'Half a litre of that target is because you take creatine. Loading needs about a litre extra.'
				: 'Creatine draws water into muscle. If you take it, your target goes up.';
		}

		qa('[data-units]').forEach(function (b) {
			b.addEventListener('click', function () {
				var next = b.getAttribute('data-units');
				if (next === state.units) return;
				var el = q('[data-weight]'), v = parseFloat(el.value);
				state.units = next;
				qa('[data-units]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
				q('[data-weight-unit]').textContent = next === 'metric' ? 'kg' : 'lb';
				el.setAttribute('aria-label', next === 'metric' ? 'Body weight in kilograms' : 'Body weight in pounds');
				if (isFinite(v)) el.value = String(Math.round(next === 'metric' ? v * LB_TO_KG : v / LB_TO_KG));
				render();
			});
		});

		qa('[data-exercise]').forEach(function (b) {
			b.addEventListener('click', function () {
				state.exercise = parseInt(b.getAttribute('data-exercise'), 10);
				qa('[data-exercise]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
				render();
			});
		});

		qa('[data-climate]').forEach(function (b) {
			b.addEventListener('click', function () {
				state.climate = b.getAttribute('data-climate');
				qa('[data-climate]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
				render();
			});
		});

		qa('[data-creatine]').forEach(function (b) {
			b.addEventListener('click', function () {
				state.creatine = b.getAttribute('data-creatine') === 'yes';
				qa('[data-creatine]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
				render();
			});
		});

		q('[data-weight]').addEventListener('input', render);
		render();
	})();
